import { DeviationMainCategory } from "./DeviationMainCategory";

export const DeviationType = {
	other: 0,
	poor_load_securing: 1,
	broken_boxes: 2,
	damaged_pallet: 3,
	frozen_pallets: 4,
	temperature_deviation: 5,
	tipped_over_pallet: 6,
	deviation_from_list: 7,
	wrong_picking: 8,
	missing_goods_plukk: 9,
	missing_label: 10,
	out_of_date: 11,
	pallet_found_should_been_sent: 12,
};

export const DeviationTypeByMainCategory = {
	[DeviationMainCategory.receiving]: {
		poor_load_securing: DeviationType.poor_load_securing,
		broken_boxes: DeviationType.broken_boxes,
		damaged_pallet: DeviationType.damaged_pallet,
		frozen_pallets: DeviationType.frozen_pallets,
		temperature_deviation: DeviationType.temperature_deviation,
		other: DeviationType.other,
	},
	[DeviationMainCategory.in_house]: {
		broken_boxes: DeviationType.broken_boxes,
		damaged_pallet: DeviationType.damaged_pallet,
		tipped_over_pallet: DeviationType.tipped_over_pallet,
		temperature_deviation: DeviationType.temperature_deviation,
		other: DeviationType.other,
	},
	[DeviationMainCategory.in_goods]: {
		deviation_from_list: DeviationType.deviation_from_list,
		wrong_picking: DeviationType.wrong_picking,
		missing_goods_plukk: DeviationType.missing_goods_plukk,
		missing_label: DeviationType.missing_label,
		out_of_date: DeviationType.out_of_date,
		pallet_found_should_been_sent: DeviationType.pallet_found_should_been_sent,
		other: DeviationType.other,
	},
};

export const IsImageRequiredByDeviationType = {
	[DeviationType.poor_load_securing]: true,
	[DeviationType.broken_boxes]: true,
	[DeviationType.damaged_pallet]: true,
	[DeviationType.frozen_pallets]: true,
	[DeviationType.temperature_deviation]: true,
	[DeviationType.tipped_over_pallet]: true,
	[DeviationType.deviation_from_list]: false,
	[DeviationType.wrong_picking]: false,
	[DeviationType.missing_goods_plukk]: false,
	[DeviationType.missing_label]: true,
	[DeviationType.out_of_date]: true,
	[DeviationType.pallet_found_should_been_sent]: true,
	[DeviationType.other]: false,
};
